const KEY = "velta_device_role";

export function getDeviceRole() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "cassa" || v === "palmare") return v;
  } catch { /* ignore */ }
  return "full";
}

export function setDeviceRole(role) {
  try {
    if (role === "cassa" || role === "palmare") localStorage.setItem(KEY, role);
    else localStorage.removeItem(KEY);
  } catch { /* ignore */ }
}
